import React from "react";

interface ClipBoundsProps {
  bounds: {
    x: number;
    y: number;
    width: number;
    height: number;
  } | null;
  children: React.ReactNode;
}

/**
 * Clips children to a rectangular bounds while still allowing the children to
 * be absolutely positioned to the original parent and behaving like they would
 * had this component not existed.
 */
export const ClipBounds: React.FC<ClipBoundsProps> = ({ bounds, children }) => {
  const shouldClip = !!bounds;
  const { x = 0, y = 0, width = 0, height = 0 } = bounds || {};

  // We have to always wrap the child in these two divs even if we didn't do any
  // clipping because when the children have iframes in it you'll see a flash as
  // the component gets recreated in order to be reparented.
  return (
    <div
      style={{
        position: "absolute",
        left: 0,
        top: 0,
        transform: `translate3d(${x}px, ${y}px, 0)`,
        width,
        height,
        overflow: shouldClip ? "hidden" : "visible",
        pointerEvents: "none",
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          transform: `translate3d(${-x}px, ${-y}px, 0)`,
        }}
      >
        {children}
      </div>
    </div>
  );
};
